export const CAMPAIGN_CAPABILITIES = {
  GROUP_BUY:          { items: true, payouts: true },
  SAVE_TO_BUY:          {contributions: true, items: true, payouts: true },
  GROUP_SAVINGS:      { contributions: true, cycles: true, payouts: true },
  FUND_COLLECT:       { contributions: true, payouts: true },
  AD_CAMPAIGN:        {},
  MARKETPLACE_LISTING: { items: true, payouts: true },
  COMMUNITY_SHOP:     { items: true, payouts: true },
  MARKETPLACE:       { items: true, payouts: true },
  PUBLIC_SHOP:       { items: true, payouts: true },
  PRIVATE_SHOP:       { items: true, payouts: true },
  TICKETING:          { participants: true },
  EVENT_REGISTRATION: { participants: true },
  DONATION_DRIVE:     { contributions: true, payouts: true },
  PREORDER:           { items: true, payouts: true },
  SUBSCRIPTION:       { contributions: true, participants: true, cycles: true, payouts: true },
  MEMBERSHIP:         { contributions: true, participants: true, payouts: true },
  COOP_PURCHASE:      { items: true, payouts: true },
  COMMUNITY_PROJECT:  { contributions: true, payouts: true },
  CHARITY:            { contributions: true, payouts: true },
  SPONSORSHIP:        { contributions: true, payouts: true },
  RAFFLE:             { participants: true },
  AUCTION:            { participants: true, bids: true },
  RSVP:               { participants: true },
  FUNDRAISER:         { contributions: true, payouts: true },
  TONTINE:            { contributions: true, participants: true, cycles: true, payouts: true },
  OTHER:              {},
}

export const CAMPAIGN_TYPE_META = {
  GROUP_BUY:          { label: 'campaign.type.groupBuy',          icon: 'cart_fill',            goal: 'quantity' },
  GROUP_SAVINGS:      { label: 'campaign.type.groupSavings',      icon: 'money_dollar_circle_fill',        goal: 'amount' },
  SAVE_TO_BUY:        { label: 'campaign.type.saveToBuy',        icon: 'cart_fill',            goal: 'quantity' },
  FUND_COLLECT:       { label: 'campaign.type.fundCollect',       icon: 'giftcard_fill',        goal: 'amount' },
  AD_CAMPAIGN:        { label: 'campaign.type.adCampaign',        icon: 'megaphone_fill',       goal: 'none' },
  PRIVATE_SHOP:       { label: 'campaign.type.privateShop',       icon: 'bag_fill',             goal: 'none' },
  TICKETING:          { label: 'campaign.type.ticketing',          icon: 'ticket_fill',          goal: 'participants' },
  EVENT_REGISTRATION: { label: 'campaign.type.eventRegistration', icon: 'calendar_badge_plus',  goal: 'participants' },
  DONATION_DRIVE:     { label: 'campaign.type.donationDrive',     icon: 'heart_fill',           goal: 'amount' },
  PREORDER:           { label: 'campaign.type.preorder',           icon: 'shippingbox_fill',     goal: 'quantity' },
  SUBSCRIPTION:       { label: 'campaign.type.subscription',       icon: 'arrow_2_circlepath',   goal: 'participants' },
  MEMBERSHIP:         { label: 'campaign.type.membership',         icon: 'person_badge_plus',    goal: 'participants' },
  COOP_PURCHASE:      { label: 'campaign.type.coopPurchase',      icon: 'shippingbox_fill',     goal: 'quantity' },
  COMMUNITY_PROJECT:  { label: 'campaign.type.communityProject',  icon: 'building_2_fill',      goal: 'amount' },
  CHARITY:            { label: 'campaign.type.charity',            icon: 'heart_circle_fill',    goal: 'amount' },
  SPONSORSHIP:        { label: 'campaign.type.sponsorship',        icon: 'star_circle_fill',     goal: 'amount' },
  RAFFLE:             { label: 'campaign.type.raffle',             icon: 'ticket_fill',          goal: 'participants' },
  AUCTION:            { label: 'campaign.type.auction',            icon: 'hammer_fill',          goal: 'none' },
  RSVP:               { label: 'campaign.type.rsvp',               icon: 'checkmark_seal_fill',  goal: 'participants' },
  FUNDRAISER:         { label: 'campaign.type.fundraiser',         icon: 'chart_bar_fill',       goal: 'amount' },
  TONTINE:            { label: 'campaign.type.tontine',            icon: 'arrow_2_circlepath',   goal: 'none' },
  OTHER:              { label: 'campaign.type.other',              icon: 'square_grid_2x2_fill', goal: 'none' },
}

export const CAMPAIGN_TYPE_FAMILIES = [
  { id: 'financialCollection', family: 'campaign.family.financialCollection',
    types: ['FUND_COLLECT', 'DONATION_DRIVE', 'CHARITY', 'FUNDRAISER',
            'COMMUNITY_PROJECT', 'SPONSORSHIP'] },
  { id: 'savingsCycles', family: 'campaign.family.savingsCycles',
    types: ['GROUP_SAVINGS', 'TONTINE', 'SUBSCRIPTION'] },
  { id: 'groupBuyProducts', family: 'campaign.family.groupBuyProducts',
    types: ['GROUP_BUY','SAVE_TO_BUY', 'PREORDER', 'COOP_PURCHASE', 'PRIVATE_SHOP'] },
  { id: 'eventsRegistrations', family: 'campaign.family.eventsRegistrations',
    types: ['TICKETING', 'EVENT_REGISTRATION', 'RSVP', 'RAFFLE'] },
  { id: 'membershipAuctions', family: 'campaign.family.membershipAuctions',
    types: ['MEMBERSHIP', 'AUCTION'] },
  { id: 'advertising', family: 'campaign.family.advertising',
    types: ['AD_CAMPAIGN'] },
]

export function capsFor(type) {
  return CAMPAIGN_CAPABILITIES[type] ?? {}
}

export function metaFor(type) {
  return CAMPAIGN_TYPE_META[type] ?? { label: type, icon: 'square', goal: 'none' }
}

/**
 * Contribution category types available when configuring per-category amounts.
 * `labelKey` points at an i18n key (campaignCreate.cat.*); `value` is what is
 * persisted in Campaign.config["categoryAmounts"].
 */
export const CONTRIBUTION_CATEGORIES = [
  { value: 'AGE', labelKey: 'category.cat.age' },
  { value: 'GRADUATION_YEAR', labelKey: 'category.cat.graduationYear' },
  { value: 'LOCATION', labelKey: 'category.cat.location' },
  { value: 'SENIORITY', labelKey: 'category.cat.seniority' },
  { value: 'MEMBERSHIP', labelKey: 'category.cat.membership' },//Basic, Premium, Patron, Lifetime

  { value: 'CUSTOM', labelKey: 'category.cat.custom' },
]

export function categoryMeta(value) {
  return CONTRIBUTION_CATEGORIES.find((c) => c.value === value) || null
}